import axios from "axios";
import authHeader from './authheader.js'

const SUPERVISINGPROFESSIONALURL = process.env.REACT_APP_APIURL + "/api/SupervisingProfessional";
const RELATIONSHIPURL = process.env.REACT_APP_APIURL + "/api/Relationship";

const getSupervisingProfessional = () => {
    return axios.get(`${SUPERVISINGPROFESSIONALURL}/getsupervisingprofessionalfirms`, { headers: authHeader() });
}
const postSupervisingProfessional = (supervisingProfessionalId, isAccepted) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/updatesupervisingprofessional`, null, { headers: authHeader(), params: { supervisingProfessionalId, isAccepted } });
}
const getFirmSupervisingProfessional = () => {
    return axios.get(`${SUPERVISINGPROFESSIONALURL}/getsupervisingprofessionals`, { headers: authHeader() });
}
const getSupervisingProfessionalsByLicenseType = (entityId, prefix) => {
    return axios.get(`${SUPERVISINGPROFESSIONALURL}/getsupervisingprofessionalsbylicensetype`, { headers: authHeader(), params: { entityId, prefix } });
}
const getSupervisingProfessionalAttestations = (entityId, prefix) => {
    //ParentTypeId = App, Renewal, Reinstatement
    return axios.get(`${SUPERVISINGPROFESSIONALURL}/getsupervisingprofessionalattestations`, { headers: authHeader(), params: { entityId, prefix } });
}
const createSpAttestation = (formattedLicenseNumber, deleteActiveAttestations = false) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/createspattestation`, null, { headers: authHeader(), params: { formattedLicenseNumber, deleteActiveAttestations } });
}
const sendSpAttestationEmail = (spAttestation) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/sendspattestationrequestemail`, spAttestation, { headers: authHeader() });
}
const postFirmSupervisingProfessional = (formattedLicenseNumber, isOwner) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/createfirmsupervisingprofessional`, null, { headers: authHeader(), params: { formattedLicenseNumber, isOwner } });
}
const deleteSupervisingProfessional = (relationshipId, supervisingProfessionalId) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/deletesupervisingprofessional`, null, { headers: authHeader(), params: { relationshipId, supervisingProfessionalId } });
}
const inactivateSupervisingProfessional = (relationshipId, supervisingProfessionalId) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/inactivatesupervisingprofessional`, null, { headers: authHeader(), params: { relationshipId, supervisingProfessionalId } });
}

const inactivateSupervisingProfessionalAsIndividual = (relationshipId, supervisingProfessionalId) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/selfinactivatesupervisingprofessional`, null, { headers: authHeader(), params: { relationshipId, supervisingProfessionalId } });
}
const postFirmSupervisingProfessionalInternal = (relationshipId, isOwner) => {
    return axios.post(`${RELATIONSHIPURL}/updatesprelationshipforfirm`, null, { headers: authHeader(), params: { relationshipId, isOwner } });
}
const createFirmSupervisingProfessionalInternal = (firmEntityId, isOwner, professionalFormattedLicenseNumber) => {
    return axios.post(`${RELATIONSHIPURL}/createactivesprelationshipforfirm`, null, { headers: authHeader(), params: { firmEntityId, isOwner, professionalFormattedLicenseNumber } });
}
const changeSupervisingProfessionalOwnership = (relationshipId, supervisingProfessionalId, firmEntityId) => {
    return axios.post(`${SUPERVISINGPROFESSIONALURL}/changesupervisingprofessionalownership`, null, { headers: authHeader(), params: { relationshipId, supervisingProfessionalId, firmEntityId } });
}

const postSpAttestationsPdf = (parentId, parentTypeId, entityId, credTypeId) => {
    return axios.post(`${process.env.REACT_APP_APIURL}/Reports/AutoAttachSpAttestations`, null, { headers: authHeader(), params: { parentId, parentTypeId, entityId, credTypeId } });
}

export default {
    getSupervisingProfessional,
    postSupervisingProfessional,
    getFirmSupervisingProfessional,
    postFirmSupervisingProfessional,
    deleteSupervisingProfessional,
    inactivateSupervisingProfessional,
    getSupervisingProfessionalsByLicenseType,
    getSupervisingProfessionalAttestations,
    postFirmSupervisingProfessionalInternal,
    createFirmSupervisingProfessionalInternal,
    changeSupervisingProfessionalOwnership,
    inactivateSupervisingProfessionalAsIndividual,
    createSpAttestation,
    sendSpAttestationEmail,
    postSpAttestationsPdf
}